/*
 * @Author: 刘枫 
 * @Date: 2021-04-28 14:12:11 
 * @Description: 报告组件
 * @Last Modified by:   liufeng 
 * @Last Modified time: 2021-04-28 14:12:11 
 */

<template>
  <div class="pay-way">
    <van-nav-bar v-show="$comm.titleShow()" left-text="返回" :title="title" @click-left="$comm.onClickLeft" left-arrow fixed>
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
    <div class="pay-way-title">{{ftitle}}
      <!-- <span class="watchers-down" v-show="fnetfileurl"><van-icon name="down" />点击下载</span> -->
    </div>
    <div class="pay-way-info">
      <span class="laiyuan" style="color: #969799;font-size: 13px;">单据号：{{fbillno}}</span>
      <div class="info-content-time">
        日期：{{fissuedate}}
      </div>
    </div>
    <div class="pay-way-content" v-html="fcontent" @click="imageChange($event)">
    </div>
    <div class="bottom-watchers-down">
      <span class="watchers-down" v-show="fnetfileurl" @click="downClick">
        <van-icon name="down" />点击下载
      </span>
    </div>
    <div v-show="xiazaiShow" @click="xiazaiShow = false" style="background: rgba(0,0,0,.5);
              width: 100%;
              position: fixed;
              top: 0;
              z-index: 1039;
              height: 100%;">
      <img style="padding: 10px;width: 95%;" :src="require('../../assets/images/xiazai.png')" />
    </div>
    <van-image-preview v-model="previewShow" fit="contain" :images="imgArr" :start-position="startPosition">
    </van-image-preview>
  </div>
</template>

<script>
export default {
  name: 'report',
  data() {
    return {
      title: '',
      ftitle: this.$route.query.ftitle,
      fcontent: this.$route.query.fcontent,
      fissuedate: this.$route.query.fissuedate,
      fnetfileurl: this.$route.query.fnetfileurl,
      fbillno: this.$route.query.fbillno,
      xiazaiShow: false,
      newimglist: [],
      previewShow: false,
      imgArr: [],
      startPosition: 0,
    }
  },
  beforeRouteEnter(to, from, next) {
    to.meta.isUseCache = true
    next()
  },
  mounted() {
    if (this.$route.query.title) {
      this.title = this.$route.query.title
    } else {
      this.title = this.$route.meta.title
    }
    window.response2({
      method: "onSingleDownload",
      cb: data => {
        this.$loading("下载中...");
        if (data.code == 0 && data.total > 0 && data.current > 0 && data.current == data.total) {
          this.$clear();
          console.log('onSingleDownload', data);
          this.$toast('下载成功')
        } else {
          this.$clear();
          this.$toast('下载失败')
        }
      }
    })
  },
  components: {
  },
  methods: {
    downClick() {
      console.log('下载地址' + this.article.ffileurl)
      if (!this.$comm.titleShow()) {
        console.log('app下载')
        // app的下载方式
        let index = this.fnetfileurl.lastIndexOf('.')
        // 获取文件类型
        this.$native.singleDownload({
          params: {
            "path": "",
            "name": this.ftitle + this.fnetfileurl.substring(index),
            "url": this.fnetfileurl,
            "unzip": false
          },
          cb: function (res) {
            console.log('singleDownload cb ', res)
          }
        })
      } else {
        // 微信端下载方式
        window.location.href = this.fnetfileurl
        // if(this.$comm.isIos()){
        //   console.log('ios下载')
        //   window.location.href = this.fnetfileurl
        // }else{
        //   console.log('安卓下载')
        //   this.xiazaiShow = true  
        // }
      }
    },
    // 点击预览
    imageChange(e) {
      var current = e.target.src
      if (current) {
        this.newimglist = this.fcontent.match(
          /<img[^>]*src=['"]([^'"]+)[^>]*>/gi
        )
        let srclist = []
        let index = 0
        for (var j = 0; j < this.newimglist.length; j++) {
          this.newimglist[j].replace(
            /<img[^>]*src=['"]([^'"]+)[^>]*>/gi,
            function (match, capture) {
              console.log('www')
              if (capture.substring(capture.indexOf('/uploadfiles')) === current.substring(current.indexOf('/uploadfiles'))) {
                index = j
              }
              srclist.push(capture);
            }
          );
        }
        this.startPosition = index
        this.newimglist = srclist
        console.log('集合' + srclist + '当前' + current + '当前位置' + this.startPosition)
        this.imgArr = this.newimglist
        this.previewShow = true
      } else {
        console.log('未点击图片')
      }
    }
  },
}
</script>

<style lang="less" scoped>
/deep/img {
  max-width: 100%;
  height: auto;
  width: 100%;
}
.pay-way {
  padding: 13px 16px;
  background: rgba(255, 255, 255, 1);
  .pay-way-title {
    font-size: 16px;
    font-weight: bold;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333;
    text-align: center;
    padding: 10px 0 10px 0;
    line-height: 1.5em;
    position: relative;
    border-bottom: 1px solid #eeeeee;
    .watchers-down {
      color: #7aa8ea;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      text-align: right;
      margin-left: 10px;
      position: absolute;
      right: 0;
      bottom: 5px;
    }
  }
  .laiyuan {
    color: #7aa8ea;
    font-size: 15px;
    margin-right: 10px;
    width: 40%;
  }
  .pay-way-info {
    display: flex;
    align-items: center;
    padding: 10px 0;
    .info-content-time {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8f8f8f;
    }
    .info-content-watchers {
      .iconfont {
        color: #8f8f8f;
        margin-left: 15px;
        font-size: 13px;
      }
      .watchers-count {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8f8f8f;
        margin-left: 5px;
      }
    }
  }
  .pay-way-content {
    padding: 10px;
    padding-bottom: 0;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333;
    overflow: auto;
  }
}
.bottom-watchers-down {
  position: relative;
  padding: 10px;
  .watchers-down {
    color: #7aa8ea;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    text-align: right;
    margin-left: 10px;
    position: absolute;
    right: 0;
    bottom: 5px;
  }
}
</style>